import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { prepareNum, unitLabel } from '@services/helper.service';
import { APP_TEXTS } from '../../../../../texts/texts';

import './../styles.scss';

class ResultsOfDesignICC extends React.Component {

	constructor(props) {
		super(props);

		this.prepareValue = props.prepareValue;
	}

	render() {
		return (
		<div className="calculation">
				{this.props.selectedItem && (
				<section className="list-type calculate-results-of-design">
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_TENSION.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>N</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_BREAKOUT.Content}</span>
										<span>&Phi;<sub>Ncb{!this.props.hasSingleAnchor && ('g')}</sub></span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.hasSingleAnchor ? 
												this.props.selectedItem.phi_Ncb : 
												this.props.selectedItem.phi_Ncbg)}
										</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_ConcreteConeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_STRENGTH.Content}</span>
										<span>&Phi;<sub>Nsa</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.phi_Nsa)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_SteelFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>
											{this.props.selectedItem.IsChemical ? 
												APP_TEXTS.CALCULATE_RESULTS_DESIGN_BOND_STRENGTH.Content :
												APP_TEXTS.CALCULATE_RESULTS_DESIGN_PULLOUT_STRENGTH.Content}
											</span>
										<span>
											&Phi;
											<sub>
												{this.props.selectedItem.IsChemical ? (this.props.hasSingleAnchor ? 'Na' : 'Nag') : 'Npn'}
											</sub>
										</span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.selectedItem.IsChemical ? 
												(this.props.hasSingleAnchor ? 
													this.props.selectedItem.phi_Na : 
													this.props.selectedItem.phi_Nag
												) :
												this.props.selectedItem.phi_Npn)}
										</td>
										<td>
											{prepareNum(this.props.selectedItem.IsChemical ? 
												this.props.selectedItem.BetaN_BondFailure : 
												this.props.selectedItem.BetaN_PullOutFailure, true, 2, true)}
										</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>V</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_BREAKOUT.Content}</span>
										<span>&Phi;<sub>Vcb{!this.props.hasSingleAnchor && ('g')}</sub></span>
								</div>
								</th>
										<td>
											{this.prepareValue(this.props.hasSingleAnchor ? 
												this.props.selectedItem.phi_Vcb : 
												this.props.selectedItem.phi_Vcbg)}
										</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_ConcreteEdgeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_PRYOUT_STRENGTH.Content}</span>
										<span>&Phi;<sub>Vcp{!this.props.hasSingleAnchor && ('g')}</sub></span>
								</div>
								</th>
										<td>
											{prepareNum(this.props.selectedItem.BetaV_PryoutFailure, true, 2, true) === '***' ? 
											'***' : this.prepareValue(this.props.hasSingleAnchor ? 
												this.props.selectedItem.phi_Vcp : 
												this.props.selectedItem.phi_Vcpg)}
										</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_PryoutFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_STRENGTH.Content}</span>
										<span>&Phi;<sub>Vsa</sub></span>
								</div>
								</th>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true) === '***' ? 
											'***' : this.prepareValue(this.props.selectedItem.phi_Vsa)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<tbody>
						<tr>
								<th scope="row">
									<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION.Content}</span>
										<span className="utilization">
											&beta;<sub>N</sub><sup>5/3</sup>&nbsp;+&nbsp;&beta;<sub>V</sub><sup>5/3</sup>&nbsp;=
										</span>
									</div>
								</th>
								<td>{prepareNum(this.props.selectedItem.Beta, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
				</section>
				)}
		</div>
		);
	}
    
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
		let hasSingleAnchor = false;
		if (data.gridSelectedItem.AnchorResults)
			hasSingleAnchor = data.gridSelectedItem.AnchorResults.length === 1 ? true : false;

		return {
			selectedItem: data.gridSelectedItem,
			loadUnit: state.main.units.load,
			hasSingleAnchor
		};
  }

  return {};
};
  
const mapDispatch = dispatch => ({
});
  
export default connect(mapState, mapDispatch)(ResultsOfDesignICC);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/components/ResultsOfDesignICC.js